import React from "react";
import { Avatar } from "@material-ui/core";

function Users({ users }) {
  return (
    <li className="media mb-3 w-75">
      <Avatar
        className="border border-primary"
        alt=""
        src={users.profileImg}
        style={{ width: "4em", height: "4em" }}
      />
      <div className="ml-2 media-body d-flex flex-column align-items-start">
        <h5 className="mt-0 mb-1"> {users.user} </h5>
        <p className="mb-0">
          {" "}
          {users.fullname} {users.dob}{" "}
        </p>
        <p className="mt-0"> {users.bio} </p>
      </div>
    </li>
  );
}

export default Users;
